const clarityId = import.meta.env.VITE_CLARITY_ID;
const unscopedPath = ['/admin'].some(route => window.location.pathname.startsWith(route));

if (!unscopedPath && clarityId) {
    (function (c, l, a, r, i, t, y){
        c[a] = c[a] || function () {(c[a].q = c[a].q || []).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", clarityId);
}
